import './triadcommunitykitchen/style';
import FormStructure from './triadcommunitykitchen/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js